import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h1>Hi people</h1>
    <p>
      This is balance, an upcoming financial dashboard for all your balances.
    </p>
  </Layout>
)

export default IndexPage
